// extracted by mini-css-extract-plugin
module.exports = {"container":"KfcsItem_container__2cm9r","active":"KfcsItem_active__1H5wM","image":"KfcsItem_image__3Tn68","image-ltr":"KfcsItem_image-ltr__1opMS","name":"KfcsItem_name__1nABd"};